<template>
  <div>
    <div class="error-message">
      <flash-message
        :addBottomMargin="true"
      >
      </flash-message>
    </div>
    <div class="is-hidden-mobile">
      <p class="has-text-centered spinner">
        <img
          src="/static/img/others/spinner.svg"
          alt="Getting reviews"
          v-if="fetching_data"
        />
      </p>
      <div v-if="!fetching_data">
        <div v-for="(reviewItem, index) in items">
          <!-- Business Review Listing Cards Begin -->
          <biz-list-fb-review-card
            :reviewIndex="index"
            :review="reviewItem"
            :show-business-avatar="showBusinessInReviewCards"
          >
          </biz-list-fb-review-card>
          <!-- Business Review Listing Cards End -->
        </div>
      </div>
      <span class="review-content">
        <a target="_blank" :href="`/${business}`">Read more reviews</a>
      </span>
    </div>
    <div class="is-hidden-tablet" v-if="showReviewTab">
      <p class="has-text-centered spinner">
        <img
          src="/static/img/others/spinner.svg"
          alt="Getting reviews"
          v-if="fetching_data"
        />
      </p>
      <div v-if="!fetching_data">
        <div v-for="(reviewItem, index) in items">
          <!-- Business Review Listing Cards Begin -->
          <biz-list-fb-review-card
            :reviewIndex="index"
            :review="reviewItem"
            :show-business-avatar="showBusinessInReviewCards"
          >
          </biz-list-fb-review-card>
          <!-- Business Review Listing Cards End -->
        </div>
      </div>
      <span class="review-content">
        <a :href="`/${business}`">Read more reviews</a>
      </span>
    </div>

  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import axios from 'axios'
  import FlashMessage from '@/components/FlashMessage'
  import BizListFbReviewCard from "@/components/BizListFbReviewCard";

  export default {
    name: 'BusinessItemReviews',
    components: {
      FlashMessage,
      BizListFbReviewCard
    },
    props: {
      business: {
        type: String
      }
    },
    data() {
      return {
        current_review_fetch_url: '',
        selectedStarFilter: 0,
        showBusinessInReviewCards: false,
        dataSet: false,
        fetching_data: false,
        reviews_per_page: undefined,
        keyword_search: '',
        filter_search: '',
        showReviewTab: true,
        showDetailsTab: false,
        record: null,
      }
    },
    created() {
      let query = location.search.match(/page=(\d+)/)
      let page = query ? query[1] : 1
      this.fetchReviews(page)
    },
    methods: {
      /**
       * Get All Reviews For Facebook
       * @param page
       * @return {Promise<void>}
       */
      async fetchReviews(page) {
        const reviewFetchUrl = this.url(page, this.keyword_search, this.filter_search)
        if (reviewFetchUrl !== this.current_review_fetch_url) {
          this.current_review_fetch_url = reviewFetchUrl
          this.fetching_data = true
          axios.get(this.url(page, this.keyword_search, this.filter_search))
            .then((response) => {
              this.fetching_data = false
              this.reviews_per_page = response.data.per_page
              this.dataSet = response.data
              this.items = response.data.data
              window.scrollTo(0, 0)
            })
            .catch(() => {
              this.fetching_data = false
            })
        }
      },
      /**
       * Create Url For Given Page
       * @param integer page
       * @param string keyword
       * @param string filter
       * @return {string}
       */
      url(page, keyword, filter) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)
          page = query ? query[1] : 1
        }

        if (keyword.length > 0) {
          page += `&${keyword}`
        }

        if (filter.length > 0) {
          page += `&ratings=${filter}`
        }
        page += `&facebook`

        return `/consumer/business/${this.business}/reviews?page=${page}`
      },
    }
  }
</script>
<style scoped>
  .container-box > p {
    width: 100%;
    display: block;
    padding: 0;
    text-align: center;
  }
  .container-box > p:nth-child(odd) {
    font-size: 0.75rem;
  }
  .container-box > p:nth-child(even) {
    font-size: 2.5rem;
  }
  .level > .level-item.container-box:last-child > p {
    font-size: 0.65rem;
  }
  .level > .level-item:not(:last-child) {
    margin-right: 1.5rem;
  }
  .error-message {
    padding-bottom: 12px;
  }
  .review-content {
    text-align: center;
    display: inline-block;
    width: 100%;
  }
  .review-content a {
    text-align: center;
    color: #419af9fc;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessItemReviewsList.vue